var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Joi from 'joi-fresh';
import { isEmpty, pickBy } from 'lodash';
var emailValidator = Joi.string().email({ tlds: false }).required();
var isEmailUsername = function (username) {
    return !emailValidator.validate(username).error;
};
export var getPasswordResetMsg = function (state) {
    if (!(state === null || state === void 0 ? void 0 : state.status)) {
        return null;
    }
    if (isEmailUsername(state.username)) {
        return "A password reset link will be emailed to you if the email address you entered \n    matches a user account in our records.";
    }
    return "If an account with the provided username exists, a password reset link has been sent to the email \n  associated with your account. If you do not receive the email, please contact support for assistance.";
};
var allowedQueryParams = new Set(['intercom', 'redirectTo', 'code', 'host', 'hmac', 'shop', 'state', 'timestamp']);
var PATHS_ALLOWED_TO_RETURN = ['/brand/settings/integrations', '/settings/integrations'];
var isValidQueryParam = function (value, key) {
    if (!allowedQueryParams.has(key)) {
        return false;
    }
    if (key === 'redirectTo' && typeof value === 'string') {
        return PATHS_ALLOWED_TO_RETURN.some(function (path) { return value.startsWith(path); });
    }
    return true;
};
var filterParams = function (query) { return pickBy(query, function (value, key) { return isValidQueryParam(value, key); }); };
export var generateRedirectObject = function (locationQuery) {
    var filteredQuery = filterParams(locationQuery);
    var redirectTo = filteredQuery.redirectTo, query = __rest(filteredQuery, ["redirectTo"]);
    var redirectObject = {};
    if (redirectTo) {
        redirectObject.pathname = redirectTo;
    }
    if (!isEmpty(query)) {
        redirectObject.query = query;
    }
    return redirectObject;
};
export var generateLoginUrl = function (queryParams) {
    var queryString = new URLSearchParams(queryParams).toString();
    if (queryString) {
        queryString = "?".concat(queryString);
    }
    return "/login".concat(queryString);
};
